import { useCallback } from 'react';
import { useQueryClient, useMutation } from 'react-query';
import request from '../../../../helpers/request';
import { createNotificationsKey } from '../queries/notifications';

const readNotification = async ({ id, markAllAsRead }) => {
  const body = markAllAsRead ? { markAllAsRead } : { id, markAllAsRead: false };

  const data = await request.post(
    `/Notification/view`,
    body,
    markAllAsRead
      ? 'Не удалось отметить как прочитанные все уведомления'
      : 'Не удалось отметить как прочитанное выбранное уведомление',
    'Error'
  );

  return data;
};

export const useReadNotification = () => {
  const queryClient = useQueryClient();

  const readMutation = useMutation(
    ({ id, markAllAsRead }) => readNotification({ id, markAllAsRead }),
    {
      onSuccess: (data) => {
        if (data !== 'Error') {
          queryClient.invalidateQueries(createNotificationsKey());
        }
      },
    }
  );

  const read = useCallback((data) => readMutation.mutate(data), [readMutation]);

  return {
    read,
    isLoading: readMutation.isLoading,
  };
};
